
import { defineComponent } from 'vue'
import { atbInfoService } from '@/services/AtbInfoService'
import { ATBInfo, EmptyATBInfo } from '@/services/ATBInfo'
import Registration from '@/components/Registration.vue'
import Information from '@/components/Information.vue'
import Pickup from '@/components/Pickup.vue'

interface AnnounceData {
  info: ATBInfo | undefined
}

export default defineComponent({
  data () {
    return {
      info: new EmptyATBInfo()
    }
  },
  components: { Information, Registration, Pickup },
  beforeRouteEnter (to, from, next) {
    if (to.params.trackingNumber) {
      atbInfoService.getByTrackingNumber(Number(to.params.trackingNumber))
        .then(info => next(vm => { const self = vm as unknown as AnnounceData; self.info = info }))
        .catch(() => next(vm => { vm.$router.push({ path: '/', query: { error: 'true' } }) }))
    }

    if (to.params.exportReference) {
      atbInfoService.getByExportReference(String(to.params.exportReference))
        .then(info => next(vm => {
          const self = vm as unknown as AnnounceData
          self.info = info
          window.history.replaceState({}, document.title, `/announce/${info.trackingNumber}`)
        }))
        .catch(() => next(vm => { vm.$router.push({ path: '/', query: { error: 'true' } }) }))
    }
  }
})
